import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import SafeIcon from '../../common/SafeIcon';
import { FiGlobe } from 'react-icons/fi';

const LanguageSelector = () => {
  const { language, setLanguage } = useTranslation();

  return (
    <div className="relative flex items-center text-sm font-medium text-gray-700">
      <SafeIcon icon={FiGlobe} className="mr-2 text-gray-500" />
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="bg-transparent border-none focus:ring-0 cursor-pointer outline-none"
      >
        <option value="el">Ελληνικά (EL)</option>
        <option value="en">English (EN)</option>
      </select>
    </div>
  );
};

export default LanguageSelector;